const SCO_URL = `${process.env.REACT_APP_SCO_ORIGIN_URL}`
const DELIVERY_ORDER_UPLOAD_BASE_URL = `${SCO_URL}/ecommerce/delivery-order-upload`

const DeliveryOrderUploadApiUrls = {
  GET_UPLOADFILE_LIST: `${DELIVERY_ORDER_UPLOAD_BASE_URL}/get`,
  UPLOAD_FILE: `${DELIVERY_ORDER_UPLOAD_BASE_URL}/upload`
}

export default DeliveryOrderUploadApiUrls